import { UsersList } from 'features/users';
import { useGroupUsersInfiniteQuery } from '../../../queries';

type P = {
  groupId: string;
};

const GroupAdminsList = ({ groupId }: P) => {
  const {
    data: administrators,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading,
  } = useGroupUsersInfiniteQuery({ filter: { groupId }, pagination: { pageSize: 10 } });

  const allAdministrators = administrators?.pages.flatMap((administratorsPaginated) => administratorsPaginated.data);

  return (
    <UsersList
      queryData={{
        fetchNextPage,
        hasNextPage,
        isFetching,
        isLoading,
      }}
      users={allAdministrators}
    />
  );
};

export default GroupAdminsList;
